import React from 'react';
import { loadSvgAsset } from '../utils/svgLoader';

// Define the props for the TabIcon component
interface TabIconProps {
  name: string;
  focused: boolean;
  color?: string;
  size?: number;
}

// Map icon names to asset paths
const iconPaths: { [key: string]: string } = {
  Home: 'images/Navbar/Home.svg',
  Team: 'images/Navbar/Team.svg',
  TaskList: 'images/Navbar/Task.svg',
  Target: 'images/Navbar/Target.svg',
  Notifications: 'images/Navbar/Notification.svg',
  Profile: 'images/Navbar/Profile.svg',
  Ledger: 'images/Navbar/Ledger.svg',
  Back: 'images/Navbar/Back.svg',
  Calendar: 'images/calendar.svg',
  TimeClock: 'images/timeClock.svg',
  Check: 'images/check.png',
  Close: 'images/close.png',
  MoneyBag: 'images/Navbar/MoneyBag.svg', // Placeholder - you may need to add this SVG
  Chart: 'images/Navbar/Chart.svg', // Placeholder
  Search: 'images/search.svg', // Placeholder - you may need to add this SVG
  Lightbulb: 'images/lightbulb.svg', // Placeholder - you may need to add this SVG
  CashIcon: 'images/Home/cash.svg',
  PointIcon: 'images/Home/point.svg',
  HighIcon: 'images/Insights/high.svg',
  LowIcon: 'images/Insights/low.svg',
  MidIcon: 'images/Insights/mid.svg',
  SunIcon: 'images/Header/sun.svg',
  MoonIcon: 'images/Header/moon.svg',
  NotificationIcon: 'images/Header/lightNotification.svg',
  LedgerPoints: 'images/ledger/points.svg',
  LedgerCash: 'images/ledger/cash.svg',
  FilterIcon: 'images/ledger/FilterIcon.svg',
  CopyIcon: 'images/ledger/CopyIcon.svg',
  BrandIcon: 'images/ledger/brand.svg',
  SortIcon: 'images/ledger/sort.svg',
  PointsIcon: 'images/ledger/points.svg',
  CardBackground: 'images/cardBackground.svg',
  WithdrawConfirmationIcon: 'images/ledger/withdrawConfirmation.svg',
  WithdrawalSuccessIcon: 'images/ledger/successWithdrawCash.svg',
  YellowCashIcon: 'images/ledger/yelowCash.svg',
  GreenCashIcon: 'images/ledger/cash.svg',
  WithdrawConfirmationPointIcon: 'images/ledger/redemptionWithdraw.svg',
  WithdrawalSuccessPointIcon: 'images/ledger/successWithdrawCash.svg',
  YellowPointIcon: 'images/ledger/yellowPoint.svg',
  GreenPointIcon: 'images/ledger/greenPoint.svg',
  OverviewIcon: 'images/teamPerformance/overview.svg',
  OverviewActiveIcon: 'images/teamPerformance/overviewActive.svg',
  InsightsIcon: 'images/teamPerformance/Insights.svg',
  InsightsActiveIcon: 'images/teamPerformance/InsightsActive.svg',
  
};

const iconPathsActive: { [key: string]: string } = {
  Home: 'images/Navbar/HomeActive.svg',
  Team: 'images/Navbar/TeamActive.svg',
  TaskList: 'images/Navbar/TaskActive.svg',
  Target: 'images/Navbar/TargetActive.svg',
  Notifications: 'images/Navbar/NotificationActive.svg',
  Profile: 'images/Navbar/ProfileActive.svg',
  Ledger: 'images/Navbar/LedgerActive.svg', // Placeholder
  Back: 'images/Navbar/BackActive.svg', // Placeholder
  Calendar: 'images/calendar.svg',
  TimeClock: 'images/timeClock.svg',
  Check: 'images/check.png',
  Close: 'images/close.png',
  MoneyBag: 'images/Navbar/MoneyBagActive.svg', // Placeholder
  Chart: 'images/Navbar/ChartActive.svg', // Placeholder
  Search: 'images/search.svg', // Placeholder - you may need to add this SVG
  Lightbulb: 'images/lightbulb.svg', // Placeholder - you may need to add this SVG
 
};

const TabIcon: React.FC<TabIconProps> = ({ name, focused, color, size = 24 }) => {
  const assetPath = focused 
    ? (iconPathsActive[name] || iconPaths[name])
    : iconPaths[name];

  if (!assetPath) {
    return null;
  }

  // Get the appropriate color based on focus state
  const getIconColor = () => {
    if (color) {
      return color;
    }
    if (focused) {
      return '#1434CB';
    } else {
      return '#8E8E93';
    }
  };

  return (
    <img
      src={loadSvgAsset(assetPath)}
      alt={name}
     
      style={{
        opacity: focused ? 1 : 0.6,
        filter: color ? `hue-rotate(${getIconColor() === '#1434CB' ? '220deg' : '0deg'})` : 'none'
      }}
    />
  );
};

export default TabIcon;